import { Box, IconButton } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { color } from "Configs/theme";
import { SORTED_COLOR_TAGS, getColorHex } from "Helpers/ColorHelper";
import React, { useEffect } from "react";
import { Control, FieldValues } from "react-hook-form";
import { useFieldControl } from "./FieldHelper";

export default function ColorField<T extends FieldValues>(props: {
	label: string;
	name: string;
	control: Control<T>;
	disabled?: boolean;
	children?: (JSX.Element | null)[];
}) {
	const { value, setValue, register, unregister } = useFieldControl<string>(
		props.control,
		props.name
	);

	function renderColorTags() {
		return SORTED_COLOR_TAGS.map((colorTag) => {
			const isSelected = value === colorTag;

			return (
				<IconButton
					key={colorTag}
					disabled={props.disabled}
					onClick={() => {
						if (!props.disabled) {
							setValue(colorTag);
						}
					}}
				>
					{isSelected ? (
						<CheckCircleIcon htmlColor={getColorHex(colorTag)} />
					) : (
						<FiberManualRecordIcon
							htmlColor={
								props.disabled ? color.secondary : getColorHex(colorTag)
							}
						/>
					)}
				</IconButton>
			);
		});
	}

	useEffect(() => {
		register(props.name);
		return () => unregister(props.name);
	}, [props.name, register, unregister]);

	return (
		<Box display="flex" justifyContent="space-between" flexWrap="wrap">
			{renderColorTags()}
		</Box>
	);
}
